module.exports = __webpack_public_path__ + "static/media/thirdareaproduct3.aba2a1e4.jpg";